// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__3XlGR","content":"RecentSearches_content__lKTH3"};